import * as React from 'react'

import { type SelectOption } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { CommonNotificationSelects } from 'modules/automations/components/Show/CommonNotification/Selects'
import {
  RecipientTypes,
  Recipients,
} from 'modules/automations/components/Show/CommonNotification/utils'
import type { Action } from 'modules/automations/store/models/Action'

import { defaultRecipientTypes, groupOptions, recipientTypes, userOptions } from './options'

interface Props {
  action: Action
  disabled: boolean
  form: Form
}

const Selects = ({ action, disabled, form }: Props) => {
  const recipientType = form.get('recipient_type').value

  useUnsafeEffect(() => {
    if (recipientType === RecipientTypes.manualSelection) {
      form.setValues({
        recipient: Recipients.access,
      })
    } else if (form.get('recipient').value === Recipients.access) {
      form.setValues({
        recipient: null,
      })
    }
  }, [form, recipientType])

  const recipientOptions = (): SelectOption[] => {
    const notifier = action.notifier

    if (!notifier) return []

    if (!recipientType) return []

    switch (recipientType) {
      case RecipientTypes.user:
        return userOptions(notifier.attributes.slug)
      case RecipientTypes.manualSelection:
        return []
      default:
        return groupOptions()
    }
  }

  const getRecipientTypes = (): SelectOption[] => {
    const trigger = action.automation?.trigger

    if (!trigger) return defaultRecipientTypes()

    return recipientTypes(trigger.attributes.slug)
  }

  return (
    <CommonNotificationSelects
      multi
      form={form}
      disabled={disabled}
      recipientOptions={recipientOptions()}
      recipientTypeOptions={getRecipientTypes()}
    />
  )
}

export default observer(Selects)
